import styled from 'styled-components';

export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SingleCardWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 1rem;
`;

export const ActionsRowWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 1rem;
`;
